
import { Grid } from '@mui/material';
import { useCallback, useState, useMemo } from 'react';
import { useLanguageContext } from '../../../../contexts/LanguageContext';
import Drawer, { IDefaultDrawerProps } from '../../../../components/Drawer';
import { ActionButton } from '../../../../components/Button';
import TextField from '../../../../components/TextField';
import SelectField from '../../../../components/SelectField';
import FormHelper from '../../../../helpers/FormHelper';


interface ISystemSettingsFilterProps extends IDefaultDrawerProps {
    categoryList: string[];
    handleApplyFilters: (formData: FormData) => void;
}


const Filters: React.FC<ISystemSettingsFilterProps> = ({
    open,
    handleClose,
    categoryList,
    handleApplyFilters
}) => {
    const { translate } = useLanguageContext();

    const [description, setDescription] = useState<string>('');
    const [category, setCategory] = useState<string[]>([]);


    const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const formData = FormHelper.Create(event);
        handleApplyFilters(formData);
        handleClose();
        // eslint-disable-next-line
    }, []);


    const footer = useMemo(() => {
        return <ActionButton
            action='apply'
            fullWidth={true}
            className='text-alwaysshow'
            type='submit'
        />;
        // eslint-disable-next-line
    }, [translate]);
    

    return (
        <Drawer
            anchor='right'
            open={open}
            handleClose={handleClose}
            title={translate('filter')}
            footer={footer}
            onSubmit={handleSubmit}
        >
            <Grid container>
                <Grid item xs={12}>
                    <TextField 
                        label={translate('description')} 
                        name='description' 
                        value={description} 
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDescription(e.target.value)}
                        required={false}
                    />
                </Grid>
                
                <Grid item xs={12}>
                    <SelectField
                        label={translate('category')}
                        name='category'
                        value={category.length > 0 ? category : ['0']}
                        multiple={true}
                        required={false}
                        onChange={e => {
                            const value = e.target.value as string[];
                            setCategory(category.length > 0 && value.includes('0') ? [] : value.filter(v => v !== '0'));
                        }}
                        data={[{ value: '0', text: translate('all') }].concat(categoryList.map(c => {
                            return {
                                text: translate(c),
                                value: c
                            };
                        }))}
                    />
                </Grid>
            </Grid>
        </Drawer>
    );
}

export default Filters;